import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";
import { CsrfToken } from "../shared/csrf_token";

// Connects to data-controller="resumin--skill-sheet-summary"
export default class extends Controller {
  static values = {
    skillSheetId: Number,
  };
  connect() {
    TurboStreamHeaders(this);
    CsrfToken(this);
  }

  fetch(e) {
    e.preventDefault();

    const params = {
      id: this.skillSheetIdValue,
    };
    const query = new URLSearchParams(params).toString();

    fetch(`/skill_sheet_generate_summary?${query}`, {
      method: "POST",
      headers: {
        ...this.turboStreamHeaders(),
        ...this.csrfToken(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
